class GeoLocationError extends Error {
  constructor({ code, message }) {
    super(message);
    this.name = 'GeoLocationError'; 
    this.code = code;
    this.message = message;
  }
}

export default GeoLocationError;
